import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import BookingSummary from "../Confirm/components/BookingSummary";
import useBookings from "hooks/useBookings";
import MirumBtn from "components/MirumBtn";
import Cost from "../Confirm/components/BookingSummary/components/Cost";
const Success = () => {
  const booking = useSelector((state) => state.booking);
  const { getAndSetSelectionByBookingId } = useBookings();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let bookingId = params.get("bookingId");
    getAndSetSelectionByBookingId(bookingId);
    console.log("Success page loaded", bookingId);
  }, []);
  return (
    <div>
      {booking && (
        <div className="container mx-auto md:py-8">
          <div className="text-center md:p-4 py-4">
            <a href="/" className="w-3/12 md:w-1/12 mx-auto block">
              <img src="/webclip.png" className="mx-auto" />
            </a>
            <h1>thank you!</h1>
            <p>we’ll confirm your surprise shortly</p>
          </div>
          <BookingSummary booking={booking} selection={booking.selection} />
          {/* COST */}
          <div className="container">
            <div className="w-full md:w-6/12 mx-auto p-4">
              <Cost bookingId={booking._id} className="w-6/12 ml-auto" />
            </div>
          </div>

          {/* DONE */}
          <div className="w-full text-right mb-8 mr-8 px-4">
            <MirumBtn className="px-10 w-full  md:w-auto" href={`/`}>
              Done
            </MirumBtn>
          </div>
        </div>
      )}
    </div>
  );
};

export default Success;
